const ENERGY_MARKET_PROGRAM_SUFFIX = '_ENERGY'

export function isEnergyMarketProgram(marketProgram: string): boolean {
  return marketProgram.endsWith(ENERGY_MARKET_PROGRAM_SUFFIX)
}
